export default __webpack_public_path__ + "static/zona-v-end-game-mb-133b4fad444cc7e58128f6c8f3d051b8.png";